<article class="pc" [id]="'post-' + post.id" [class.is-highlighted]="highlighted" [class.is-system]="isSystem">
  <header class="pc-head">
    <button type="button" class="pc-avatar" (click)="openAuthor()" [attr.aria-label]="post.author.name">
      @if (post.author.avatar) {
        <img [src]="imageUrl(post.author.avatar)" alt="" (error)="post.author.avatar = null" />
      } @else {
        {{ initials(post.author.name) }}
      }
    </button>
    <div class="pc-who">
      <div class="pc-line">
        <button type="button" class="pc-name" (click)="openAuthor()">{{ post.author.name }}</button>
        @if (post.author.handle) {
          <span class="pc-handle">&#64;{{ post.author.handle }}</span>
        }
      </div>
      <div class="pc-line pc-sub">
        <a class="pc-time" [title]="post.created_at | date: 'medium'" (click)="openPost()">{{ timeAgo(post.created_at) }}{{ post.is_edited ? ' · edited' : '' }}</a>
        @if (showSource && sourceName) {
          <span class="pc-sep" aria-hidden="true">·</span>
          <button type="button" class="pc-source" (click)="openSource()"><i class="fa" [ngClass]="sourceIcon"></i>{{ sourceName }}</button>
        }
      </div>
    </div>
    @if (post.is_pinned) {
      <span class="pc-pin" title="Pinned"><i class="fa fa-thumb-tack"></i><span class="pc-pin-text">Pinned</span></span>
    }
    <app-social-post-menu
      [canEdit]="post.can_edit && !editing"
      [canDelete]="post.can_delete === true"
      [canPin]="post.can_pin === true"
      [pinned]="post.is_pinned === true"
      [canReport]="canReport"
      (edit)="startEdit()"
      (remove)="confirmingDelete = true"
      (report)="reporting = true"
      (pin)="togglePin()"></app-social-post-menu>
  </header>

  @if (post.activity) {
    <p class="pc-label" [class.pc-label--system]="isSystem"><i class="fa" [class.fa-bolt]="isSystem" [class.fa-tag]="!isSystem"></i>{{ post.activity }}</p>
  }

  @if (!editing) {
    @if (post.content) {
      <p class="pc-text">{{ post.content }}</p>
    }
  } @else {
    <div class="pc-edit">
      <textarea #editBox [(ngModel)]="editDraft" rows="3" aria-label="Edit post"></textarea>
      <div class="pc-edit-actions">
        <app-social-emoji-picker [target]="editBox"></app-social-emoji-picker>
        <button type="button" class="btn btn-dark" (click)="editing = false">Cancel</button>
        <button type="button" class="btn btn-theme" [disabled]="!editDraft.trim() || savingEdit" (click)="saveEdit()">
          {{ savingEdit ? 'Saving…' : 'Save' }}
        </button>
      </div>
    </div>
  }

  <div class="pc-media">
    <app-social-image-gallery [images]="post.images || []" [image]="post.image"></app-social-image-gallery>
    @if (post.video) {
      <video class="pc-video" [src]="imageUrl(post.video)" controls preload="metadata"></video>
    }
    <app-social-poll [post]="post"></app-social-poll>
  </div>

  <footer class="pc-actions">
    <button type="button" [class.is-on]="post.liked_by_me" [attr.aria-pressed]="post.liked_by_me" (click)="toggleLike()" aria-label="Like">
      <i class="fa" [class.fa-heart]="post.liked_by_me" [class.fa-heart-o]="!post.liked_by_me"></i><span>{{ post.likes_count || '' }}</span>
    </button>
    <button type="button" [class.is-on]="showComments && comments !== 'always'" (click)="onComment()" aria-label="Comments">
      <i class="fa fa-comment-o"></i><span>{{ post.comments_count || '' }}</span>
    </button>
    <button type="button" [class.is-on]="post.boosted_by_me" [disabled]="post.can_boost === false" (click)="boost()"
      [attr.title]="post.can_boost === false ? 'You can\'t share your own post' : 'Share with your followers'" aria-label="Share">
      <i class="fa fa-retweet"></i><span>{{ post.boosts_count || '' }}</span>
    </button>
  </footer>

  @if (showComments) {
    <div class="pc-comments">
      <app-social-comments [post]="post" (countChange)="post.comments_count = $event"></app-social-comments>
    </div>
  }
</article>

<app-social-confirm-dialog
  [open]="confirmingDelete"
  title="Delete post?"
  message="This post will be removed, along with its likes and comments. This can't be undone."
  [busy]="deleting"
  (confirm)="confirmDelete()"
  (cancel)="confirmingDelete = false"></app-social-confirm-dialog>

@if (reporting) {
  <app-social-report-dialog [open]="true" [target]="{ postId: post.id }" (closed)="reporting = false"></app-social-report-dialog>
}
